var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-select-base", {
        attrs: {
          model: _vm.selected,
          items: _vm.items,
          loading: _vm.loading,
          label: _vm.label,
          error: _vm.error,
          errors: _vm.errors,
          search: _vm.search,
          clearable: _vm.clearable,
          autoComplete: _vm.autoComplete,
          showAdd: _vm.showAdd,
          disabled: _vm.disabled,
          autofocus: _vm.autofocus,
          dense: _vm.dense,
        },
        on: {
          "update:model": function ($event) {
            _vm.selected = $event
          },
          "update:search": function ($event) {
            _vm.search = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }